import { useEffect, useState } from "react";
import { api } from "../api/client";
import { useAuth } from "../contexts/AuthContext";

// The WS Location user's OWN location codes (Raintree codes), read from
// /auth/me — which reads the same `user_locations` join the server-side
// access guard reads. One source of truth.
//
// Used to constrain the booking-location dropdown (CRM Queue) and the
// assigned-clinic field (Manual Referral Entry). Both are courtesies: the
// boundary itself is enforced server-side on every write. Empty for every
// other role, so no unrelated surface changes behaviour.
export function useMyLocationCodes() {
  const { user } = useAuth();
  const isLocationUser = user?.role === "location";
  const [codes, setCodes] = useState([]);
  // clinic-telehealth-book-at: sites this login may BOOK at beyond its own
  // (server-decided; empty unless CLINIC_TELEHEALTH_BOOK_LOCATIONS lists it).
  const [extraCodes, setExtraCodes] = useState([]);
  const [loading, setLoading] = useState(isLocationUser);

  useEffect(() => {
    if (!isLocationUser) {
      setCodes([]);
      setExtraCodes([]);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    api.get("/auth/me")
      .then((r) => {
        if (cancelled) return;
        setCodes(r.data?.location_codes || []);
        setExtraCodes(r.data?.booking_extra_codes || []);
      })
      .catch(() => { if (!cancelled) { setCodes([]); setExtraCodes([]); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [isLocationUser]);

  return { codes, extraCodes, loading, isLocationUser };
}
